// import Component from './src/index.vue';
// //@ts-ignore
// // const requireAll = requireContext => {
// //     console.log('requireContext',requireContext)
// //     return requireContext.keys().map(requireContext)
// // }
// // const req = require.context('@/fit-ui/assets/icon', false, /\.svg$/)
// // requireAll(req)
// export default Component;


import Vue, { CreateElement, VNode } from 'vue';
import Icon from './src/index.vue';
import Tick from './src/tick.vue';
import Security from './src/security.vue';
import Camera from './src/camera.vue';
import Reload from './src/reload.vue';
import Verification from './src/verification.vue';
import WechatPay from './src/wechatPay.vue';
const svgMap = {
    tick: Tick,
    security: Security,
    camera: Camera,
    reload: Reload,
    verification: Verification,
    wechatPay:WechatPay
};
export default Vue.extend({
    name: 'FitIcon',
    props: {
        icon: { // 弹出框标题
            type: String,
            default: 'info',
        },
        fill: {
            type: String,
        },
        size: {
            type: [String, Number],
        },
    },
    render(createElement: CreateElement): VNode {
        // @ts-ignore
        if (svgMap[this.icon]) {
            // @ts-ignore
            return createElement(svgMap[this.icon], {
                props: {
                    fill: this.fill,
                    size: this.size,
                },
                class: {
                    [`fit-icon-${this.icon}`]: true
                }
            });
        }
        return createElement(Icon, {
            props: {
                icon: this.icon,
            },
            class: {
                [`fit-icon-${this.icon}`]: true
            }
        });
    },
});
